import { OrderAssetReason, OrderAssetState, RequestOrigin } from '@leid/api-assets'
import { ImageSequenceStep } from '@leid/api-products'

export type AliasInfo = {
  id: number
  visualTag: string
  available: boolean
  sublocationId: number
}

export type OpenDoorStepData = {
  sublocationId: number
  deviceId: number
  doorName: string

  locationId: number | undefined
  orderId: number
  customerId: number | undefined
}

export type PickUpAssetsStepData = {
  assets: AliasInfo[]

  orderId: number
  orderItemId: number
  locationId: number | undefined
}

export type ReturnAssetsStepData = {
  orderItemId: number

  asset: AliasInfo | undefined
}

export type TakePhotosStepData = {
  orderId: number
  orderItemId: number
  locationId: number | undefined
  imageSequenceSteps: ImageSequenceStep[]
}

export type CommitStepData = {
  orderId: number
  orderItemId: number
  customerId: number | undefined
  productId: number | undefined
  flowDirection: FlowDirection
}

export type ManyAssetsReminderStepData = {
  flowDirection: FlowDirection
  productName: string
  amount: number

  orderId: number
  orderItemId: number
  locationId: number | undefined
}

export enum FlowDirection {
  NONE = 'NONE',
  PICKUP = 'PICKUP',
  RETURN = 'RETURN',
}

export enum StepType {
  OPEN_DOOR = 'OPEN_DOOR',
  PICKUP_ASSET = 'PICKUP_ASSET',
  RETURN_ASSET = 'RETURN_ASSET',
  TAKE_PHOTOS = 'TAKE_PHOTOS',
  COMMIT = 'COMMIT',
  MANY_ASSETS_REMINDER = 'MANY_ASSETS_REMINDER',
}

export type FlowStepDescription = {
  type: StepType
  data:
    | OpenDoorStepData
    | PickUpAssetsStepData
    | ReturnAssetsStepData
    | TakePhotosStepData
    | ManyAssetsReminderStepData
    | CommitStepData
}

export enum DeviceDirection {
  IN = 'IN',
  OUT = 'OUT',
}

export type SelectedAssetData = {
  state: OrderAssetState
  reason: OrderAssetReason
  orderId: number
  orderItemId?: number
  assetId?: number
  locationId?: number
  sublocationId?: number
  timestamp: Date
  origin: RequestOrigin
  visualTag: string
}
